import { ContentClipDetailResponse, ContentClipListResponse, } from '@wit-support/admin-contracts';
import { CONTENT_API_BASE as BASE, contentQs as qs, contentRequest as request } from '../api.js';
/**
 * GET /clips в постраничном режиме: `page`/`pageSize` передаются ВСЕГДА —
 * без них admin-api отдаёт прежнюю «всю папку» без `total`.
 */
export function listClipsPage(query) {
    return request(ContentClipListResponse, `${BASE}/clips${qs({
        account: query.account,
        q: query.q,
        sort: query.sort,
        dir: query.dir,
        tier: query.tier,
        network: query.network,
        overridesOnly: query.overridesOnly ? 'true' : undefined,
        page: String(query.page),
        pageSize: String(query.pageSize),
    })}`);
}
/** GET /clips/:id — карточка клипа; `page`/`pageSize` — страница истории использований. */
export function getClip(id, paging) {
    return request(ContentClipDetailResponse, `${BASE}/clips/${encodeURIComponent(id)}${qs({
        page: String(paging.page),
        pageSize: String(paging.pageSize),
    })}`);
}
//# sourceMappingURL=clips.js.map